let notifyFn = null;

export const registerNotifier = (fn) => {
  notifyFn = fn;
};

export const notifySuccess = (message) => {
  notifyFn?.({ message, severity: "success" });
};

export const notifyError = (message) => {
  notifyFn?.({ message, severity: "error" });
};

export const notifyInfo = (message) => {
  notifyFn?.({ message, severity: "info" });
};

export const notifyWarning = (message) => {
  notifyFn?.({ message, severity: "warning" });
};
